module.exports = __webpack_public_path__ + "img/Picture27.ee752d1d.png";